import type {
  NumberStatesValues,
  PrevPayrollProviderValues,
  WhatToUseValues,
  WhatToUseFindYourPlanValues,
  WhoToPayValues,
} from 'packages/signup/components/SurveyQuestions';
import type { ContextContents } from 'packages/signup/components/signupProvider';

export const calculateExploreProgressPercentage = (signupContext: ContextContents) => {
  const { numberStates, prevPayrollProvider, whatToUse, whoToPay } = signupContext;

  const answers: (
    | NumberStatesValues
    | PrevPayrollProviderValues
    | WhatToUseValues
    | WhoToPayValues
    | undefined
  )[] = [
    numberStates,
    prevPayrollProvider,
    (whatToUse as WhatToUseValues).length === 0 ? undefined : (whatToUse as WhatToUseValues),
    whoToPay?.length === 0 ? undefined : whoToPay,
  ];

  return answers.map(ans => (ans ? 100 / answers.length : 0)).reduce((a, b) => a + b);
};

export const calculateFindYourPlanProgressPercentage = (signupContext: ContextContents) => {
  const { numberStates, prevPayrollProvider, whatToUseFindYourPlan, whoToPay } = signupContext;

  const answers: (
    | NumberStatesValues
    | PrevPayrollProviderValues
    | WhatToUseFindYourPlanValues
    | WhoToPayValues
    | undefined
  )[] = [
    numberStates,
    prevPayrollProvider,
    (whatToUseFindYourPlan as WhatToUseFindYourPlanValues).length === 0
      ? undefined
      : (whatToUseFindYourPlan as WhatToUseFindYourPlanValues),
    whoToPay?.length === 0 ? undefined : whoToPay,
  ];

  return answers.map(ans => (ans ? 100 / answers.length : 0)).reduce((a, b) => a + b);
};
